import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import ImageGrid from './ImageGrid.tsx';
import type { ImageGridPayload } from './types.ts';

const MOUNT_ID = 'REACT_pdp_imageGrid';

const parsePayload = (root: HTMLElement): ImageGridPayload | null => {
  const raw = root.dataset.payload;
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ImageGridPayload;
  } catch (err) {
    Sentry.captureException(err);
    return null;
  }
};

export const mountImageGrid = (): void => {
  const rootElement = document.getElementById(MOUNT_ID);
  if (!rootElement) return;

  const payload = parsePayload(rootElement);
  if (!payload) return;

  const root = createRoot(rootElement);
  root.render(
    <Sentry.ErrorBoundary>
      <ImageGrid payload={payload} />
    </Sentry.ErrorBoundary>
  );
};

mountImageGrid();
